import { addDoc, collection, deleteDoc, doc, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const getAll = async (account, menu) => {
  const snapshot = await getDocs(collection(db, `menus/${account}/menu/${menu}/products`));
  const products = snapshot.docs.map((doc) => ({ id: doc.id, order: 0, active: false, ...doc.data() }));
  return products.sort((oldRelease, newRelease) => {
    const comparecategoryId = `${oldRelease.categoryId}`.localeCompare(`${newRelease.categoryId}`);
    const compareOrder = `${oldRelease.order}`.localeCompare(`${newRelease.order}`);
    const compareName = oldRelease.name.localeCompare(newRelease.name);
    return comparecategoryId || compareOrder || compareName;
  });
};

const add = async (account, menu, categoryId, data) => {
  const categoryRef = doc(db, `menus/${account}/menu/${menu}/categories`, categoryId);
  await addDoc(collection(db, `menus/${account}/menu/${menu}/products`), { ...data, category: categoryRef });
  return data;
};

const edit = async (account, menu, id, data) => {
  await updateDoc(doc(db, `menus/${account}/menu/${menu}/products`, id), {
    ...data,
  });
};

const remove = async (account, menu, id) => {
  await deleteDoc(doc(db, `menus/${account}/menu/${menu}/products`, id));
};

const funcs = {
  getAll,
  add,
  edit,
  remove,
};

export default funcs;
